export const description =
  "Isoler ses murs (ITI ou ITE) supprime 20 à 25 % des déperditions. Cumul MaPrimeRénov’ + Prime CEE + éco-PTZ + TVA 5,5 % 2026, sous condition R ≥ 3,7 m².K/W.";
